"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TextArea = antd_1.Input.TextArea;
var DlgApiError = /** @class */ (function (_super) {
    __extends(DlgApiError, _super);
    function DlgApiError(props) {
        return _super.call(this, props) || this;
    }
    DlgApiError.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                errorMessage: data.errorMessage,
                dialogTitle: data.dialogTitle,
                errorFatal: data.errorFatal,
                srvErrorCode: data.srvErrorCode,
                srvErrorInfo: data.srvErrorInfo,
                srvErrorReason: data.srvErrorReason
            });
        });
        this.setState({
            tabKey: "1",
            visible: this.props.controller.DATA.visible,
            errorMessage: this.props.controller.DATA.errorMessage,
            dialogTitle: this.props.controller.DATA.dialogTitle,
            errorFatal: this.props.controller.DATA.errorFatal,
            srvErrorCode: this.props.controller.DATA.srvErrorCode,
            srvErrorInfo: this.props.controller.DATA.srvErrorInfo,
            srvErrorReason: this.props.controller.DATA.srvErrorReason
        });
    };
    DlgApiError.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgApiError.prototype.handleClose = function () {
        this.props.controller.Close();
        if (this.props.controller.DATA.onClose) {
            this.props.controller.DATA.onClose();
        }
    };
    DlgApiError.prototype.handleLogout = function () {
        this.props.controller.Close();
        if (this.props.controller.DATA.onLogout) {
            this.props.controller.DATA.onLogout();
        }
    };
    DlgApiError.prototype.onTabClick = function (tab_Key) {
        this.setState({ tabKey: tab_Key });
    };
    DlgApiError.prototype.getButtons = function () {
        if (this.state.errorFatal) {
            return (React.createElement(antd_1.Button, { type: "danger", style: { width: "120px" }, ghost: true, onClick: this.handleLogout.bind(this) }, "\u0412\u042B\u0425\u041E\u0414"));
        }
        else {
            return (React.createElement(antd_1.Button.Group, null,
                React.createElement(antd_1.Button, { type: "danger", style: { width: "120px" }, ghost: true, onClick: this.handleLogout.bind(this) }, "\u0412\u042B\u0425\u041E\u0414"),
                React.createElement(antd_1.Button, { type: "primary", style: { width: "120px" }, ghost: true, onClick: this.handleClose.bind(this) }, "\u0417\u0410\u041A\u0420\u042B\u0422\u042C")));
        }
    };
    DlgApiError.prototype.render = function () {
        return React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, wrapClassName: "vertical-center-modal", closable: false, maskClosable: false, footer: this.getButtons() },
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.state.tabKey, onChange: this.onTabClick.bind(this) },
                React.createElement(antd_1.Tabs.TabPane, { tab: "\u0418\u041D\u0424\u041E\u0420\u041C\u0410\u0426\u0418\u042F", key: "1" },
                    React.createElement(antd_1.Alert, { message: this.state.errorMessage, type: "error", showIcon: true })),
                React.createElement(antd_1.Tabs.TabPane, { tab: "\u041F\u041E\u0414\u0420\u041E\u0411\u041D\u041E", key: "2" },
                    React.createElement("div", null,
                        React.createElement("div", { style: { marginBottom: 16 } },
                            React.createElement(antd_1.Input, { placeholder: "\u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438", value: this.state.srvErrorCode, readOnly: true })),
                        React.createElement("div", { style: { marginBottom: 16 } },
                            React.createElement(TextArea, { placeholder: "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E\u0431 \u043E\u0448\u0438\u0431\u043A\u0435", value: this.state.srvErrorInfo, readOnly: true, rows: 4 })),
                        React.createElement("div", { style: { marginBottom: 16 } },
                            React.createElement(TextArea, { placeholder: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043E\u0448\u0438\u0431\u043A\u0438", readOnly: true, value: this.state.srvErrorReason, rows: 4 }))))));
    };
    return DlgApiError;
}(React.Component));
exports.default = DlgApiError;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ui/DlgApiError.tsx
// module id = 1722
// module chunks = 0